import * as fromDatatype from "../datatype-library/index";

export interface bl_sfa_qualification_criteria_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	type: fromDatatype.VarcharDatatypeInterface;
	qualification_set_guid: fromDatatype.GuidDataFieldInterface;
	required:boolean;
}

export class bl_sfa_qualification_criteria_hdr_RowClass
	implements bl_sfa_qualification_criteria_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	type: fromDatatype.VarcharDatatypeInterface;
	qualification_set_guid: fromDatatype.GuidDataFieldInterface;
	required:boolean;
}
